import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { isFunc, isArray } from '../utils/is';
import Tree from '../Tree';
import { PureComponent } from '../component';
import { getUidStr } from '../utils/uid';
import { treeSelectClass } from './styles';
import Result from './Result';
import absoluteList from '../AnimationList/AbsoluteList';
import { docSize } from '../utils/dom/document';
import { getParent } from '../utils/dom/element';
import List from '../AnimationList';
import { getLocale } from '../locale';
import { isRTL } from '../config';
import { getDirectionClass } from '../utils/classname';
var DefaultValue = {
  clearable: false,
  compressed: false,
  absolute: false,
  multiple: false,
  line: false,
  renderItem: function renderItem(e) {
    return e;
  },
  height: 300,
  data: [],
  defaultExpanded: []
};
var ScaleList = List(['fade', 'scale-y'], 'fast');
var OptionList = absoluteList(function (_ref) {
  var focus = _ref.focus,
      other = _objectWithoutProperties(_ref, ["focus"]);

  return (
    /*#__PURE__*/
    React.createElement(ScaleList, Object.assign({
      show: focus
    }, other))
  );
});

var isDescendent = function isDescendent(el, id) {
  if (el.getAttribute('data-id') === id) return true;
  if (!el.parentElement) return false;
  return isDescendent(el.parentElement, id);
};

var TreeSelect =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TreeSelect, _PureComponent);

  var _super = _createSuper2(TreeSelect);

  function TreeSelect(props) {
    var _this;

    _classCallCheck(this, TreeSelect);

    _this = _super.call(this, props);
    _this.treeSelectId = void 0;
    _this.handleClick = void 0;
    _this.handleBlur = void 0;
    _this.resetAbsoluteListPosition = void 0;
    _this.inputReset = void 0;
    _this.element = void 0;
    _this.state = {
      focus: false,
      position: 'drop-down'
    };
    _this.treeSelectId = "treeSelect_".concat(getUidStr());
    _this.onExpandHandler = _this.onExpandHandler.bind(_assertThisInitialized(_this));
    _this.getResetPosition = _this.getResetPosition.bind(_assertThisInitialized(_this));
    _this.setInputReset = _this.setInputReset.bind(_assertThisInitialized(_this));
    _this.renderActive = _this.renderActive.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.renderItem = _this.renderItem.bind(_assertThisInitialized(_this));
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleState.bind(_assertThisInitialized(_this), true);
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleState.bind(_assertThisInitialized(_this), false);
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_this));
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    _this.handleClickAway = _this.handleClickAway.bind(_assertThisInitialized(_this));
    _this.shouldFocus = _this.shouldFocus.bind(_assertThisInitialized(_this));
    _this.getDataByValues = _this.getDataByValues.bind(_assertThisInitialized(_this));
    var componentRef = {
      getDataByValues: _this.getDataByValues
    };

    if (props.getComponentRef) {
      if (isFunc(props.getComponentRef)) {
        props.getComponentRef(componentRef);
      } else {
        props.getComponentRef.current = componentRef;
      }
    }

    return _this;
  }

  _createClass(TreeSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      var _this$props = this.props,
          onFilter = _this$props.onFilter,
          datum = _this$props.datum,
          mode = _this$props.mode;
      datum.mode = mode; // clear filter

      if (prevState.focus !== this.state.focus && !this.state.focus && onFilter) {
        setTimeout(function () {
          onFilter('', 'blur');
        }, 400);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(TreeSelect.prototype), "componentWillUnmount", this).call(this);

      this.clearClickAway();
    }
  }, {
    key: "onExpandHandler",
    value: function onExpandHandler() {
      var _this2 = this;

      if (this.resetAbsoluteListPosition) {
        setTimeout(function () {
          _this2.resetAbsoluteListPosition(true);
        });
      }

      if (this.props.onExpand) {
        var _this$props2;

        (_this$props2 = this.props).onExpand.apply(_this$props2, arguments);
      }
    }
  }, {
    key: "getText",
    value: function getText(key) {
      return this.props.empty || getLocale(key);
    }
  }, {
    key: "setInputReset",
    value: function setInputReset(fn) {
      this.inputReset = fn;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var _this$props3 = this.props,
          datum = _this$props3.datum,
          multiple = _this$props3.multiple;
      var value = datum.getValue();
      if (multiple) return value;
      return value.length ? value[0] : '';
    }
  }, {
    key: "getDataByValue",
    value: function getDataByValue(value) {
      if (value === null || value === undefined) return value;
      var _this$props4 = this.props,
          datum = _this$props4.datum,
          multiple = _this$props4.multiple;

      if (multiple && Array.isArray(value)) {
        return value.map(function (id) {
          return datum.getDataById(id);
        });
      }

      return datum.getDataById(value);
    }
  }, {
    key: "getDataByValues",
    value: function getDataByValues(values) {
      var datum = this.props.datum;

      if (isArray(values)) {
        return values.map(function (id) {
          return datum.getDataById(id);
        });
      }

      return datum.getDataById(values);
    }
  }, {
    key: "getResetPosition",
    value: function getResetPosition(update) {
      this.resetAbsoluteListPosition = update;
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.element = el;
    }
  }, {
    key: "shouldFocus",
    value: function shouldFocus(el) {
      if (el.getAttribute('data-id') === this.treeSelectId) return true;
      if (getParent(el, ".".concat(treeSelectClass(getDirectionClass('result'))))) return true;
      return false;
    }
  }, {
    key: "bindClickAway",
    value: function bindClickAway() {
      document.addEventListener('mousedown', this.handleClickAway);
    }
  }, {
    key: "clearClickAway",
    value: function clearClickAway() {
      document.removeEventListener('mousedown', this.handleClickAway);
    }
  }, {
    key: "handleClickAway",
    value: function handleClickAway(e) {
      var desc = isDescendent(e.target, this.treeSelectId);

      if (!desc) {
        this.clearClickAway();
        this.props.onBlur(e);
        this.handleState(false, e);
      }
    }
  }, {
    key: "handleState",
    value: function handleState(focus, e) {
      if (this.props.disabled === true) return;
      if (focus === this.state.focus) return; // click close icon

      if (focus && e && e.target.classList.contains(treeSelectClass('close'))) return;
      var _this$props5 = this.props,
          _this$props5$height = _this$props5.height,
          height = _this$props5$height === void 0 ? DefaultValue.height : _this$props5$height,
          onCollapse = _this$props5.onCollapse;
      var position = this.props.position;
      var windowHeight = docSize.height;
      var bottom = height + this.element.getBoundingClientRect().bottom;
      if (bottom > windowHeight && !position) position = 'drop-up';
      if (onCollapse) onCollapse(focus);
      this.setState({
        focus: focus,
        position: position || 'drop-down'
      });

      if (focus) {
        this.bindClickAway(); // onFocus()
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (!this.shouldFocus(e.target)) return;
      this.props.onFocus(e);
      this.bindClickAway();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var onEnterExpand = this.props.onEnterExpand;

      if (e.keyCode === 13) {
        e.preventDefault(); // enter only can open

        if (!this.state.focus) {
          if (typeof onEnterExpand === 'function') {
            var canOpen = onEnterExpand(e);
            if (canOpen === false) return;
          }

          this.handleState(true);
        }
      } // fot close the list


      if (e.keyCode === 9) {
        this.props.onBlur(); // e.preventDefault()

        if (this.state.focus) {
          this.handleState(false, e);
        } else {
          this.clearClickAway();
        }
      }
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(data) {
      var datum = this.props.datum;
      var dataKey = data && datum.isUnMatch(data) ? data.value : datum.getKey(data);
      datum.set(dataKey, 0);
      this.handleChange(data, datum.getKey(data));
    }
  }, {
    key: "handleChange",
    value: function handleChange(data, id) {
      var _this$props6 = this.props,
          datum = _this$props6.datum,
          multiple = _this$props6.multiple,
          disabled = _this$props6.disabled,
          onChange = _this$props6.onChange,
          onChangeAddition = _this$props6.onChangeAddition;
      if (disabled === true || datum.isDisabled(id)) return;
      var current = datum.getDataById(id);

      if (!multiple) {
        datum.setValue([]);
        datum.set(datum.getKey(data), 1);
        this.handleState(false);
      }

      var value = this.getValue();
      if (onChange) onChange(value, current, id ? (datum.getPath(id) || {}).path : undefined);

      if (typeof onChangeAddition === 'function') {
        onChangeAddition({
          data: this.getDataByValue(value),
          checked: multiple ? datum.get(id) : undefined,
          current: current
        });
      }
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      var _this$props7 = this.props,
          multiple = _this$props7.multiple,
          onChangeAddition = _this$props7.onChangeAddition;
      this.props.datum.setValue([]);
      this.props.onChange(multiple ? [] : '');

      if (typeof onChangeAddition === 'function') {
        onChangeAddition({
          data: multiple ? [] : null
        });
      }

      this.handleState(false);
      this.element.focus();
    } // only as default renderResult

  }, {
    key: "renderItem",
    value: function renderItem(data) {
      var renderItem = this.props.renderItem;
      return typeof renderItem === 'function' ? renderItem(data) : data[renderItem];
    }
  }, {
    key: "renderActive",
    value: function renderActive(data, expanded, active, id) {
      var _this$props8 = this.props,
          renderItem = _this$props8.renderItem,
          datum = _this$props8.datum;
      var item = typeof renderItem === 'function' ? renderItem(data, expanded, active, id) : data[renderItem];
      return (
        /*#__PURE__*/
        React.createElement("span", {
          title: typeof item === 'string' ? item : undefined,
          className: treeSelectClass('content-wrapper', active && 'selected', datum.isDisabled(datum.getKey(data)) && getDirectionClass('disabled'))
        }, item)
      );
    }
  }, {
    key: "renderTreeOptions",
    value: function renderTreeOptions() {
      var _this3 = this;

      var _this$state = this.state,
          focus = _this$state.focus,
          position = _this$state.position;
      var _this$props9 = this.props,
          multiple = _this$props9.multiple,
          datum = _this$props9.datum,
          data = _this$props9.data,
          absolute = _this$props9.absolute,
          height = _this$props9.height,
          zIndex = _this$props9.zIndex,
          compressed = _this$props9.compressed,
          value = _this$props9.value;
      var props = {};
      var TreeKeys = ['mode', 'data', 'datum', 'defaultExpanded', 'defaultExpandAll', 'disabled', 'expanded', 'keygen', 'loader', 'onExpand', 'renderItem', 'line', 'parentClickExpand', 'childrenKey', 'expandIcons'];
      TreeKeys.forEach(function (k) {
        ;
        props[k] = _this3.props[k];
      });
      props.value = datum.getValue();

      if (multiple) {
        // @ts-ignore only use second param
        props.onChange = this.handleChange;
      } else {
        props.onClick = this.handleChange;
        props.renderItem = this.renderActive;
        props.active = props.value.length ? props.value[0] : undefined;
      }

      var content = data.length === 0 ?
      /*#__PURE__*/
      React.createElement("span", {
        className: treeSelectClass(getDirectionClass('option'))
      }, this.getText('noData')) :
      /*#__PURE__*/
      React.createElement(Tree, Object.assign({
        className: treeSelectClass(!multiple && 'single')
      }, props, {
        dataUpdate: false,
        onExpand: this.onExpandHandler
      }));
      return (
        /*#__PURE__*/
        React.createElement(OptionList, {
          getResetPosition: this.getResetPosition,
          absolute: absolute,
          rootClass: treeSelectClass(position, isRTL() && 'rtl'),
          parentElement: this.element,
          position: position,
          focus: focus,
          "data-id": this.treeSelectId,
          className: treeSelectClass('options'),
          style: {
            maxHeight: height,
            overflowY: 'auto'
          },
          fixed: "min",
          zIndex: zIndex,
          value: multiple && !compressed ? value : undefined
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: treeSelectClass('tree-wrapper')
        }, content))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          placeholder = _this$props10.placeholder,
          onFilter = _this$props10.onFilter,
          compressed = _this$props10.compressed,
          compressedBound = _this$props10.compressedBound,
          multiple = _this$props10.multiple,
          datum = _this$props10.datum,
          clearable = _this$props10.clearable,
          disabled = _this$props10.disabled,
          size = _this$props10.size,
          filterText = _this$props10.filterText,
          result = _this$props10.result,
          renderUnmatched = _this$props10.renderUnmatched,
          innerTitle = _this$props10.innerTitle,
          keygen = _this$props10.keygen,
          data = _this$props10.data;
      var className = treeSelectClass('inner', size, this.state.focus && 'focus', this.state.position, multiple && 'multiple', disabled === true && getDirectionClass('disabled'));
      var renderResult = this.props.renderResult || this.renderItem;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          // eslint-disable-next-line
          tabIndex: disabled === true ? -1 : 0,
          ref: this.bindElement,
          className: className,
          "data-id": this.treeSelectId,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          onClick: this.handleClick
        },
        /*#__PURE__*/
        React.createElement(Result, {
          filterText: filterText,
          onClear: clearable ? this.handleClear : undefined,
          onRemove: this.handleRemove,
          onFilter: onFilter,
          result: result,
          disabled: disabled,
          datum: datum,
          focus: this.state.focus,
          multiple: multiple,
          placeholder: placeholder,
          renderResult: renderResult,
          setInputReset: this.setInputReset,
          compressed: compressed,
          compressedBound: compressedBound,
          renderUnmatched: renderUnmatched,
          innerTitle: innerTitle,
          keygen: keygen,
          data: data
        }), this.renderTreeOptions())
      );
    }
  }]);

  return TreeSelect;
}(PureComponent);

TreeSelect.defaultProps = DefaultValue;
export { TreeSelect as default };